import { get } from '_src/utils/http'

// 获取合集列表
export function getCollectList(data) {
  return get('/api/inftspace/collect/v3/list', data).then((res) => {
    return res
  })
}

// 获取合集详情
export function getCollectInfoServer(data) {
  return get('/api/inftspace/collect/v3/info', data).then((res) => {
    return res
  })
}
